package pipeline

import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.getHeight
import com.github.chosamuel.kishibe.application.getWidth
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.graphics.Mesh
import com.github.chosamuel.kishibe.graphics.createMesh
import geometry.PolarGrid
import numRungs
import numSpokes
import kotlin.math.floor

fun Application.createIrisMesh(): Mesh{
    val irisMesh = createMesh()
    val pg = PolarGrid(
        getWidth() * 0.5,
        getHeight() * 0.5,
        getWidth() * 0.08,
        numRungs,
        numSpokes
    )
    //vertices
    pg.createPoints().forEach { irisMesh.addVertex(it) }
    //color
    repeat(irisMesh.vBuffer.numVertices()){
        if(it == 0){
            irisMesh.addColor(Color(0.0,0.0,1.0))
        } else {
            val r = (it-1)%pg.rungs
            val t = floor((it-1.0)/pg.rungs.toDouble())
            irisMesh.addColor(Color(r.toDouble(),t,1.0))
        }
    }
    //indices
    pg.getIndices().forEach {
        irisMesh.addIndex(it.toShort())
    }
    return irisMesh
}